import React from 'react';
import { useTranslation } from 'react-i18next';
import slugify from 'slugify';
import styles from './styles/News.module.scss';

import { OmaLummeApp } from '../../omaLummeContext';

import NewsItem from './NewsItem';

// Types.
import { NewsProps } from '../../types/news';
import Pagination from './Pagination';
import Button from '../Common/Button';

const News: React.FunctionComponent<NewsProps> = (props: NewsProps) => {
  const { t } = useTranslation();

  const { news } = OmaLummeApp.useState();

  const { articles, benefits, teaser } = props;

  const ARTICLES_PER_PAGE = 10;

  const [page, setPage] = React.useState<number>(1);

  const parsedNews: string[] = [];

  const newsArray = news
    .map((article, key): React.JSX.Element | undefined => {
      const isBenefit = import.meta.env.VITE_HUBSPOT_TAG_BENEFITS
        ? article.tagIds.includes(parseInt(import.meta.env.VITE_HUBSPOT_TAG_BENEFITS))
        : false;
      const isGoodToKnow = import.meta.env.VITE_HUBSPOT_TAG_GOODTOKNOW
        ? article.tagIds.includes(parseInt(import.meta.env.VITE_HUBSPOT_TAG_GOODTOKNOW))
        : false;
      if (article && (benefits === true ? isBenefit : true) && (articles === true ? isGoodToKnow : true) && !parsedNews.includes(article.id)) {
        parsedNews.push(article.id);
        return (
          <NewsItem
            to={`/article/${slugify(article.title).toLowerCase()}`}
            key={key}
            title={article.title}
            time={(benefits && isBenefit) || (!benefits && articles && isGoodToKnow) ? undefined : article.publishDate}
          />
        );
      }
      return undefined;
    })
    .filter((news) => news);

  const teaserNews = (
    <div id="news">
      {newsArray.slice(0, 3)}
      {!benefits && !articles && (
        <Button className="buttonWhite" link="/news">
          {t('customerService:news.allNewsLink')}
        </Button>
      )}
      {benefits && (
        <Button className="buttonWhite" link="/news/benefits">
          {t('customerService:news.allBenefitsLink')}
        </Button>
      )}
      {!benefits && articles && (
        <Button className="buttonWhite" link="/news/articles">
          {t('customerService:news.allArticlesLink')}
        </Button>
      )}
    </div>
  );

  const pageCount = Math.ceil(newsArray.length / ARTICLES_PER_PAGE);

  const fullNews = (
    <div className={styles.news} aria-live="polite">
      {newsArray.slice((page - 1) * ARTICLES_PER_PAGE, page * ARTICLES_PER_PAGE)}
      {newsArray.length > ARTICLES_PER_PAGE && (
        <Pagination newsAmount={newsArray.length} page={page} setPage={setPage} pageCount={pageCount} perPage={ARTICLES_PER_PAGE} />
      )}
    </div>
  );

  return (
    <>
      {teaser && teaserNews}
      {!teaser && fullNews}
    </>
  );
};

export default News;
